module.exports = __webpack_public_path__ + "img/body-1-lg.2ccd9850.png";